import React, { useState } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, useRefresh
} from 'react-admin';
import {
    useMediaQuery, makeStyles, MenuItem, TextField as MuiTextField, Button, Dialog, DialogContent, DialogActions, CircularProgress
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import config from './config.json'
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { hideName, hideMobileNumber} from "./sharedData";

const useStyles = makeStyles({
    root: {
        width: "100%"
    },
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    muiPopoverPaper: {
        height: "400px",
        width: "260px",
        padding: "5px 10px 5px 10px"
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 380
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
});

const CATEGORY = "WARRIOR USER SECTION"

export const WarriorUsers = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Name", "Mobile"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Name");
    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } };

    React.useEffect(() => {
        eventTracker(CATEGORY, " WARRIOR USER LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
        </div>
        <List
            style={{ marginTop: 20 }}
            {...props}
            title="Warrior Users"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination />}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => hideName(record.name)}
                        secondaryText={record => (<div>
                            {record.mobile && <div><span style={{ color: "#5a5a5a" }}>Mobile No: </span>{hideMobileNumber(record.mobile)}</div>}
                            {record.user_type && <div><span style={{ color: "#5a5a5a" }}>User Type: </span>{record.user_type}</div>}
                            {!viewOnly && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                                <WarriorUsersRequest {...props} record={record} />
                            </div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
                        <FunctionField source='mobile' label='Mobile' render={(record) => record && record.mobile ? hideMobileNumber(record.mobile) : '-'} />
                        <TextField source="user_type" label="User Type" />
                        {!viewOnly && <FunctionField source='approved' label='Approved' render={(record) => record && <WarriorUsersRequest {...props} record={record} />} />}
                    </Datagrid>
            }
        </List>
    </div>
};

function WarriorUsersRequest({ record }) {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles()
    //const notify = useNotify()
    const refresh = useRefresh()

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [name, setName] = useState("");
    const [userType, setUserType] = useState("")
    const [loading, setLoading] = useState(false)

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const requestHandler = () => {


        if (record.approved === 0) {
            if (name === "" || name == null) {
                return notify("Name is Required", "warning")
            }
            if (userType === "" || userType == null) {
                return notify("User Type is Required", "warning")
            }
        }

        if (record.approved === 0) {
            setLoading(true)
            fetch(`${config.HOST_NAME}/crm/v3/warrioruser/approve`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify({ warrior_user_id: record.id, name: name, userType: userType })
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        notify(json.message, "success");
                        setLoading(false)
                        refresh()
                        closeDialog()
                        eventTracker(CATEGORY, "APPROVE WARRIOR USER")
                    } else {
                        notify(json.message, "warning");
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    notify("Something Went Wrong", "warning");
                });
        } else {
            setLoading(true)
            fetch(`${config.HOST_NAME}/crm/v3/warrioruser/remove`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                },
                body: JSON.stringify({ warrior_user_id: record.id })
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
                        notify(json.message, "success");
                        setLoading(false)
                        refresh()
                        closeDialog()
                        eventTracker(CATEGORY, "REMOVE WARRIOR USER")
                    } else {
                        notify(json.message, "warning");
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    notify("Something Went Wrong", "warning");
                });
        }

    }

    React.useEffect(() => {
        setName(record.name ? record.name : "")
        setUserType(record.user_type ? record.user_type : "")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>

            <Button className='customStyleActionBtn' onClick={openDialog} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: record.approved === 1 ? "#de575e" : "#18cc69", color: "#FFF", borderRadius: 50 }}>
                {record.approved === 1 ? "Remove" : "Accept"}
            </Button>

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
                {
                    record.approved === 0 ?
                        <DialogContent>
                            <p style={{ marginBottom: 20 }}>Please fill following details.</p>
                            <MuiTextField
                                className='changePasswordTextField'
                                variant="outlined"
                                size="small"
                                label="Name"
                                value={name}
                                onChange={event => setName(event.target.value)}
                                style={{ display: "block", marginBottom: 20 }}
                            />
                            <MuiTextField
                                className='changePasswordTextField'
                                variant="outlined"
                                size="small"
                                label="User Type"
                                select
                                value={userType}
                                style={{ width: "230px" }}
                                onChange={(event) => setUserType(event.target.value)}
                            >
                                <MenuItem value="admin">Admin</MenuItem>
                                <MenuItem value="warehouse">Warehouse</MenuItem>
                                <MenuItem value="operation">Operation</MenuItem>
                                <MenuItem value="inventory">Inventory</MenuItem>
                                <MenuItem value="data_entry">Data Entry</MenuItem>
                                <MenuItem value="ieems">IEEMS</MenuItem>
                                <MenuItem value="paytmIeems">Paytm IEEMS</MenuItem>
                            </MuiTextField>
                        </DialogContent>
                        :
                        <DialogContent>
                            <p>Are you sure you want remove this <strong>User</strong></p>
                        </DialogContent>
                }
                <DialogActions>
                    <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        Close
                    </Button>
                    <Button onClick={requestHandler} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: record.approved === 1 ? "#de575e" : "#18cc69", color: "#FFF" }} disableElevation>
                        {record.approved === 1 ? "Remove" : "Accept"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}